export const LifecycleHook = Object.freeze({
    Lock: 'lock',
    Unlock: 'unlock',
    Clear: 'clear',
    Import: 'import',
    PreImport: 'pre-import',
    Migrate: 'migrate',
    Start: 'start',
    Stop: 'stop',
    Restart: 'restart',
    Load: 'load',
    Unload: 'unload',
    Create: 'create',
    Restore: 'restore',
    RestoreCompleted: 'restore-completed',
    AssetsSynced: 'assets-synced',
    ChangePassphrase: 'change-passphrase',
});
